import axios from "axios";
import * as API from "../utils/api";

export class AppService{

    // initialize
    public constructor() {
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
        axios.defaults.xsrfCookieName = "csrftoken"
        axios.defaults.withCredentials = true
    }

    public async fetchData(url: string){
        return await axios.get(url);
    }

    public async sendQuizResponse(url: string, quizData: string){
        return await axios.post(url, null,
            {
                params: {
                    quizResponse: quizData
                }
            }
        );
    }

    public async saveQuizResponse(quizData: any, stepId: string, friendlyStepId: string = ""){
        return await axios.post(API.SAVE_RESPONSE, {quizData: quizData, stepId: stepId, friendlyStepId: friendlyStepId})
    }

    public async getQuizResponse(stepId: string){
        return await axios.post(API.QUIZ_RESPONSE, {stepId: stepId})
    }

    public async getSupportingContent(friendlyStepId: string) {
        return await axios.post(API.SUPPORTING_CONTENT, {friendlyStepId: friendlyStepId})
    }


    public async advanceTask(url: string, taskId: string){
        return await axios.post(url, {taskId: taskId}, {
                headers: {'Content-Type': 'application/json'}
            }
        );
    }

    public async completeProgram(taskId: string){
        return await axios.post(API.COMPLETE_PROGRAM, {taskId: taskId});
    }

    public async checkIfUserIsAP(){
        return await axios.post(API.CHECK_AP);
    }
}